import { Attributes } from "html-react-parser/lib/attributes-to-props"
import { attributesToProps } from "html-react-parser"
import React, { useContext, useEffect } from "react"
import classNames from "../utils/classnames"
import { UserInterfaceContext } from "../context/UserInterfaceContext"

interface ITabsProps {
  children: React.ReactNode
}
interface ITabWithAttributes {
  children: React.ReactNode
  attribs: Attributes
}

function Tabs({ children }: ITabsProps): JSX.Element {
  // console.log(`Tabs`, children)
  return <div className="wp-block-georgiancollege-tabs">{children}</div>
}

export function TabList({ children }: ITabsProps): JSX.Element {
  // console.log(`TabList`, children)
  // const { activePageTab, setActivePageTab } = useContext(UserInterfaceContext)
  // useEffect(() => {
  //   if (activePageTab === ``) {
  //     setActivePageTab(
  //       () =>
  //         children &&
  //         children[0]?.props?.children?.props?.attribs[`data-content-id`]
  //     )
  //   }
  // }, [])
  return (
    <ul className="wp-block-georgiancollege-tabs__list flex flex-wrap gap-[2px] p-0" role="tablist">
      {children}
    </ul>
  )
}

export function TabItem({ children }: ITabsProps): JSX.Element {
  // console.log(`TabItem`)
  return <li className="wp-block-georgiancollege-tabs__item">{children}</li>
}

export function TabLink({
  children,
  attribs,
}: ITabWithAttributes): JSX.Element {
  // console.log(`TabLink`)
  const { activePageTab, setActivePageTab } = useContext(UserInterfaceContext)
  const htmlAttributes = attributesToProps(attribs)
  useEffect(() => {
    const { hash } = window.location

    if (hash === `#tab/${htmlAttributes[`data-content-id`]}`) {
      setActivePageTab(() => htmlAttributes[`data-content-id`])
    } else if (htmlAttributes.className.includes(`active`)) {
      setActivePageTab(() => htmlAttributes[`data-content-id`])
    }
  }, [])
  return (
    <a
      {...htmlAttributes}
      role='tab'
      href={htmlAttributes.href.replace(`/tab/`, `/#tab/`)}
      onClick={(): void => setActivePageTab(htmlAttributes[`data-content-id`])}
      className={classNames(
        // htmlAttributes.className,
        `text-base underline font-normal !text-black px-4 py-2 m-0 rounded-t-sm whitespace-nowrap`,
        `border-t-4  border-x border-x-lightgray`,
        activePageTab === htmlAttributes[`data-content-id`]
          ? `border-t-green bg-white`
          : `border-t-lightgray bg-lightgray`,
        `hover:bg-white hover:border-t-green`, // `before:content-[""] before:block before:w-full before:h-1 before:bg-green`,
        `wp-block-georgiancollege-tabs__link`
      )}
    >
      {children}
    </a>
  )
}

export function TabContent({
  children,
  attribs,
}: ITabWithAttributes): JSX.Element {
  // console.log(`TabContent`)
  const { activePageTab } = useContext(UserInterfaceContext)
  const htmlAttributes = attributesToProps(attribs)
  return activePageTab === htmlAttributes.id ? (
    <div {...htmlAttributes} className="wp-block-georgiancollege-tabs__content">
      {children}
    </div>
  ) : (
    <></>
  )
}

export default Tabs
